import { useState, useEffect } from "react";

const NAME = "MIGUEL FARIA";

const LoadingScreen = ({ onDone }) => {
  const [exit, setExit] = useState(false);

  useEffect(() => {
    const prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const duration = prefersReduced ? 0 : 1900;
    const exitDuration = prefersReduced ? 0 : 2500;

    const t1 = setTimeout(() => setExit(true), duration);
    const t2 = setTimeout(() => onDone(), exitDuration);
    return () => { clearTimeout(t1); clearTimeout(t2); };
  }, [onDone]);

  return (
    <div className={`loading-screen${exit ? " loading-screen--exit" : ""}`} aria-hidden="true">
      <div className="loading-content">
        <div className="loading-logo">
          {NAME.split("").map((c, i) => (
            <span
              key={i}
              className="loading-letter"
              style={{ animationDelay: `${i * 55}ms` }}
            >
              {c === " " ? " " : c}
            </span>
          ))}
          <span className="loading-dot-red">.</span>
        </div>
        <div className="loading-sub">Photography</div>
        <div className="loading-progress-wrap">
          <div className="loading-progress-bar" />
        </div>
      </div>
    </div>
  );
};

export default LoadingScreen;
